import Spinner from '@/components/Spinner';
import { useSelector } from 'react-redux';
import { m, AnimatePresence } from 'framer-motion';
import { useEffect, useMemo } from 'react';
import { action } from '@/lib/api.js';
import setPath from '@/lib/setPath.js';
import { useUser as useClerkUser } from '@clerk/clerk-react';

const loaderVariants = {
  hidden: {
    opacity: 0,
    y: 40,
    transition: { type: 'spring', duration: 0.5, bounce: 0 }
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring', duration: 0.5, bounce: 0, delay: 0.3 }
  },
  exit: {
    opacity: 0,
    y: 40,
    transition: { type: 'spring', duration: 0.5, bounce: 0 }
  }
};

const SignUpLoader = () => {
  const transitionSignUp = useSelector((state) => state.ui.transitionSignUp);
  const { user: clerkUser } = useClerkUser();

  const showLoader = useMemo(() => {
    if (transitionSignUp) {
      return true;
    }
    const isNotInSignUpOrLogin = !window.location.pathname?.includes('/signup') && !window.location.pathname?.includes('/login');
    return !!clerkUser && !clerkUser?.publicMetadata?.companyId && isNotInSignUpOrLogin;
  }, [clerkUser?.publicMetadata, transitionSignUp, window.location.pathname]);

  // This is a fallback to prevent the loader from staying on screen indefinitely
  useEffect(() => {
    if (transitionSignUp) {
      const timeout = setTimeout(() => {
        if (window.location.pathname?.includes('/signup')) {
          setPath('/', { replace: true });
        }
        action('SET_TRANSITION_SIGN_UP', false);
      }, 20000);

      return () => clearTimeout(timeout);
    }
  }, [transitionSignUp]);

  return (
    <AnimatePresence>
      {showLoader && (
        <m.div //
          className="sign-up-loader"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={loaderVariants}>
          <div className="content">
            <Spinner size={24} />
            <p>Getting things ready...</p>
          </div>
        </m.div>
      )}
    </AnimatePresence>
  );
};

export default SignUpLoader;
